<template>
    <div class="search-form-item">
        <div class="label" :style="{width: `${labelWidth}px`}">
            <slot name="label">{{ label }}</slot>
        </div>
        <div class="input">
            <slot />
        </div>
    </div>
</template>
<script>
export default {
    props: {
        label: {
            type: String,
            default: 'label',
        },
        labelWidth: {
            type: Number,
            default: 150,
        },
    },
};
</script>
<style lang="scss">
.search-form-item {
    display: flex;
    flex-direction: row;
    gap: 20px;
    margin-bottom: 10px;
    align-items: center;

    @media (max-width: 910px) {
        flex-direction: column;
        gap: 0px;
    }

    &:last-child {
        margin-bottom: 0;
    }

    >.label {
        font-size: 10.5pt;
        color: #606266;
        margin-top: 8px;
        margin-bottom: 5px;
        width: 150px;
        text-align: right;

        @media (max-width: 910px) {
            width: 100%;
            text-align: left;
        }
    }
    >.input {
        .el-input__inner,
        .el-radio-button__inner {
            border-width: 2px;
        }

        .horizontal-inputs {
            display: flex;
            align-items: center;
            gap: 6px;

            >.spacer {
                color: #606266;
                font-size: 10pt;
            }
        }
    }
}
</style>
